import apiUrlProvider, {
  APPLY_COUPON,
  APPLY_FREE_PAYMENT,
  APPLY_HAPPY_HOUR,
  CLEAR_COUPON,
} from 'constants/api-endpoints';
import { fetchPost, fetchPut } from 'utils/services/fetch';

export const requestCheckCoupon = (token: string, code: string) => {
  const url = apiUrlProvider.get(APPLY_COUPON);
  return fetchPost(url, { coupon: code }, { isAuth: true, token });
};

export const requestCheckHappyHour = (token: string) => {
  const url = apiUrlProvider.get(APPLY_HAPPY_HOUR);
  return fetchPost(url, {}, { isAuth: true, token });
};

export const requestClearCoupon = (token: string) => {
  const url = apiUrlProvider.get(CLEAR_COUPON);
  return fetchPut(url, {}, { isAuth: true, token });
};

export const requestFreePayment = (token: string, tipPercentage: number) => {
  const url = apiUrlProvider.get(APPLY_FREE_PAYMENT);
  return fetchPost(url, { tip_percentage: tipPercentage }, { isAuth: true, token });
};
